import React, { useContext } from 'react';
import { LineTitle } from '../../article';
import { OutIndexContext, useActionsOutIndex, useDispatchOutIndex, useOut } from '../../../../context/inventory/OutIndexProvider';
import Moment from 'react-moment';
import { FORMAT_DATE_TIME_MOMENT, STATUS_EXCUTED, STATUS_IN_PROGRESS } from '../../../../api/constant';
import { Link, useNavigate } from 'react-router-dom';
import StatusEntry from '../../entry/form/StatusEntry';
import Pagination from '../../../app/atoms/Pagination';
import { types } from '../../../../reducers/inventory/outIndexReducer';

export const HandOutIndex = () => {

  const state = useOut();
  const dispatch = useDispatchOutIndex();
  const action =useActionsOutIndex();

  //const [{ listOutsHeaders }, { pageFilter }] = useContext(OutIndexContext);
  const navigate = useNavigate();

  const redirectOutExit = (order_number, exit_movement_id)=>{
    navigate(`/inventory/test/${order_number}/exit/${exit_movement_id}`)
  }

  const redirectHandOut = (exit_movement_id)=>{
    navigate(`/inventory/handOut/${exit_movement_id}`)
  }

  return (
    <div className="container-fluid">
      <LineTitle title={"Lista de salidas"} />

      <table className="table table-warehouse">
        <thead className="thead-dark thead-warehouse">
          <tr>
            <th scope="col">ID</th>


            <th scope="col">Tipo de salida</th>

            <th scope="col">Estado</th>
            <th scope="col">Cant. Referencias</th>
            <th scope="col">Fecha documento</th>
            <th scope="col">Responsable</th>
            {/* <th scope="col">Última actualización</th> */}
            <th scope="col">Almacen</th>

          </tr>
        </thead>
        <tbody>
          {state.elements.map((item) => {
            return (
              <tr key={item.id} className="cursor-pointer td-hoverme" onClick={()=>{item.type=="KT"&&redirectOutExit(item.order_number, item.id) || item.type=="CM"&&redirectHandOut(item.id)}} >
                <td>
                <span>{item.id}</span>
                </td>
                <td>
                <span>{item.type_movement_code=="02"?"Salida":"Entrada"} por {item.type=="CM"&&"Consumo" || item.type=="KT"&&"kit"}</span>
                </td>
                <td>
                  <StatusEntry status_id={item.status_id} />
                </td>

                <td>{item.quantity_references}</td>

                <td>
                  {item.status_id == STATUS_EXCUTED ?
                  <Moment format={FORMAT_DATE_TIME_MOMENT}>
                  {item.date_movement}
                  </Moment>
                  :
                  <Moment format={FORMAT_DATE_TIME_MOMENT}>
                    {item.created_at}
                  </Moment>}
                  
                </td>
                <td>{item.user_name}</td>
                <td>{item.id_warehouse} - {item.warehouse_name} </td>


              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="flex justify-end">
        <Pagination
          onChangepage={(e) =>
            dispatch({
              type: types.CHANGE_INPUT_FILTER_OUTS,
              payload: { name: "page", value: e },
            })
          }
          page={state.filter.page}
          limit={state.filter.limit}
          rows={state.rows}
        />
      </div>

    </div>
  )
}
